import pako from "pako";
import * as actionFunction from "../../../actions/common";
// Function to extract attribute_type, field, and headerName
export function extractAttributes(data) {
  return data.map((item) => ({
    attribute_type: item.attribute_type,
    field: item.field,
    headerName: item.headerName,
    is_filter: item.is_filter,
  }));
}

// Function to extract keys as an array
export function extractKeys(data, key) {
  return data.map((item) => item[key]);
}
// Function to check if any key from fieldsArray exists in inputValue
export function hasValidKey(input, key) {
  if (input.hasOwnProperty(key)) {
    return key;
  }
  return false;
}
// Function to check if any value in the object is not blank
export function isObjectNotEmpty(obj, fieldName = "") {
  if (fieldName != "") {
    for (let key in obj) {
      if (key == fieldName && obj[key] !== "") {
        return true;
      }
    }
    return false;
  } else {
    for (let key in obj) {
      if (obj[key] !== "") {
        return true;
      }
    }
    return false;
  }
}
//const columnsData = apiData.columns;
export function findMissingKeys(data) {
  let allKeys = {};
  data.forEach((obj) => {
    Object.keys(obj).forEach((key) => {
      allKeys[key] = true;
    });
  });

  const allKeysArray = Object.keys(allKeys);

  return allKeysArray.filter((key) => {
    return data.some((obj) => !(key in obj));
  });
}
//Singly key pass
export function findDuplicateValue(data, key) {
  let seen = {};
  let duplicates = [];

  data.forEach((obj) => {
    const value = obj[key];
    if (seen[value]) {
      duplicates.push(value);
    } else {
      seen[value] = true;
    }
  });

  return duplicates;

  /**
   *Example usage:
   *const duplicateProductKeys = findDuplicateValue(data, 'product');
   *console.log("Duplicate product keys:", duplicateProductKeys);
   */
}
//pass multiple keys
export function findDuplicateValues(data, keys) {
  let seen = {};
  let duplicates = {};

  keys.forEach((key) => {
    duplicates[key] = [];
  });

  data.forEach((obj) => {
    keys.forEach((key) => {
      const value = obj[key];
      if (seen[key] === undefined) {
        seen[key] = {};
      }
      if (seen[key][value]) {
        duplicates[key].push(value);
      } else {
        seen[key][value] = true;
      }
    });
  });

  return duplicates;
  /**
   *Example usage:
   *const duplicateValues = findDuplicateValues(data, ['product', 'customer_id', 'email']);
   *console.log("Duplicate values:", duplicateValues);
   */
}

// Function to parse cookies into an object
export function getCookie(cookieName) {
  const cookies = document.cookie.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(cookieName + "=")) {
      return cookie.substring(cookieName.length + 1);
    }
  }
  return null;
}

export function maskEmail(value, visibleLength, fieldName) {
  try {
    if (checkCrmPermission()) return value;

    if (!value || value === "NULL") return "-NA-"; // Ensure a default return value

    if (fieldName === "phone_number") {
      if (value.length > visibleLength) {
        let maskedPhone =
          value.slice(0, -visibleLength).replace(/./g, "x") +
          value.slice(-visibleLength);
        return maskedPhone;
      }
      return value; // If phone number is too short, return as is
    }

    if (fieldName === "email") {
      if (!value.includes("@")) return "-NA-"; // Handle malformed email
      let [localPart, domain] = value.split("@");
      if (!domain) return "-NA-"; // Ensure domain exists
      let maskedLocalPart = localPart.replace(/./g, "x");
      return maskedLocalPart + "@" + domain;
    }

    return value; // Default return for unknown field types
  } catch (err) {
    console.log("Error in maskEmail:", err.message);
    return "-NA-"; // Return a default value instead of `undefined`
  }
}

export function maskPhone(value, visibleLength) {
  if (checkCrmPermission()) return value;
  let maskedPhone =
    value.slice(0, -visibleLength).replace(/./g, "x") +
    value.slice(-visibleLength);
  return maskedPhone;
}

export function checkCrmPermission() {
  let crmPermission = localStorage.getItem("crm_permission");
  if (crmPermission) {
    return +crmPermission;
  }
  return false;
}

export function encodeDecodeRequest(debug = null, requests = null) {
  if (!debug) return pako.gzip(JSON.stringify(requests));
  return JSON.stringify(requests);
}

export async function retriveResponeValue(debug = null, promise = null) {
  if (!debug) {
    let bufferdata = await promise.arrayBuffer();
    return await actionFunction.decompressjsondata(bufferdata);
  }
  return await promise.json();
}

export const getDisplayValue = (colDef, data, options = []) => {
  const field = colDef.field;
  const value = data[field];

  if (field === "company_name") {
    return value || "-NA-";
  }

  if (colDef.attribute_type === "api") {
    const val = colDef.options&& colDef.options.find((it) => it.id === value);
    return val && val.value || "-NA-";
  }

  if (colDef.attribute_type === "date") {
    return value
      ? new Date(value * 1000).toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        })
      : "-NA-";
  }

  if (["account_manager", "sales_manager", "tse_owner"].includes(field)) {

       
    return value
    ? (function () {
        const match = options.find(it => it.user_uuid === value);
        return match && match.name ? match.name : '-NA-';
      })()
    : '-NA-';
  }

  if (field === "email" || field === "phone_number") {
    return maskEmail(value, 4, field);
  }

  return value || "-NA-";
};



// WEBPACK FOOTER //
// ./src/components/crm/customer/Utility.js